import { render, staticRenderFns } from "./GelirInfo.vue?vue&type=template&id=7094ee96"
import script from "./GelirInfo.vue?vue&type=script&lang=ts"
export * from "./GelirInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports